import { useState } from "react";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";

const Description = ({ description }: { description: string }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const width = useWindowWidth();
  const maxChars = 270;

  const toggleExpand = () => setIsExpanded(!isExpanded);

  return (
    <div className="max-lg:leading-[22px] max-lg:text-[16px] text-white font-light text-xl mt-6 leading-[34px]">
      <p className="max-lg:overflow-hidden">
        {isExpanded || description.length <= maxChars || width > 768
          ? description
          : `${description.substring(0, maxChars)}...`}
        {description.length > maxChars && (
          <button
            className="text-[#87B7FF] text-[15px] leading-5 ml-1 max-lg:inline-block hidden no-underline"
            onClick={toggleExpand}
          >
            {isExpanded ? "less" : "more"}
          </button>
        )}
      </p>
    </div>
  );
};

export default Description;
